export namespace RouterStore {
  export interface IRouterStoreState {

  }

  export enum ROUTE_NAME {
    PAGE_404 = '404',
    MAIN_PAGE = 'homepage',
    RHIZOME_PAGE = 'rhizom',
    PATH_OVERVIEW_PAGE = 'themenpfade',
    PATH_PAGE = 'thema',
    FILM = 'film',
    ABOUT = 'about',
    ICONS = 'icons',
    DETAIL_PAGE = 'detail',
    SEARCH_PAGE = 'search',
    DATA_PROTECTION = 'data-protection',
    IMPRINT = 'imprint',
  }

  export enum ROUTE_PATH {
    PAGE_404 = '/404',
    MAIN_PAGE = '/',
    RHIZOME_PAGE = '/rhizom',
    PATH_OVERVIEW_PAGE = '/themenpfade',
    PATH_PAGE = '/thema',
    FILM = '',
    ABOUT = '/about',
    ICONS = '/icons',
    DETAIL_PAGE = '/detail',
    SEARCH_PAGE = '',
    DATA_PROTECTION = '/data-protection',
    IMPRINT = '/imprint',
  }
}
